import type { NavigationConfig } from '@ingenico/react-section-utils';
import { listenCapabilities } from '@ingenico/react-section-utils';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';

export function deviceManagementNavigation(spi: DeviceManagementSpiPort): NavigationConfig {
  return [
    {
      labelKey: 'navigation.page.myapps',
      icon: 'services',
      order: 6,
      children: [
        {
          labelKey: 'navigation.page.apps',
          href: 'apps',
          onlyShowWhen: listenCapabilities(spi, [], ['apps.showInGlobalNavigation', 'apps.list']),
        },
        {
          labelKey: 'navigation.page.os',
          href: 'os',
          onlyShowWhen: listenCapabilities(spi, [], ['os.showInGlobalNavigation', 'os.list']),
        },
        {
          labelKey: 'navigation.page.systemPackages',
          href: 'system-packages',
          onlyShowWhen: listenCapabilities(spi, [], ['systemPackages.showInGlobalNavigation', 'systemPackages.list']),
        },
        {
          labelKey: 'navigation.page.resources',
          href: 'resources',
          onlyShowWhen: listenCapabilities(spi, [], ['resources.showInGlobalNavigation', 'resources.list']),
        },
        {
          labelKey: 'navigation.page.rki',
          href: 'rki',
          onlyShowWhen: listenCapabilities(spi, [], ['rki.showInGlobalNavigation', 'rki.detail']),
        },
      ],
    },
    {
      labelKey: 'navigation.page.configuration',
      icon: 'configuration',
      order: 5,
      children: [
        {
          labelKey: 'navigation.page.profiles',
          href: 'configurations',
          order: 1,
          onlyShowWhen: listenCapabilities(spi, [], ['configProfile.showInGlobalNavigation', 'configProfile.list']),
        },
        {
          labelKey: 'navigation.page.modules',
          href: 'modules',
          order: 2,
          onlyShowWhen: listenCapabilities(spi, [], ['modules.showInGlobalNavigation', 'modules.list']),
        },
      ],
    },
    {
      labelKey: 'navigation.page.deployments',
      icon: 'deployments',
      href: 'deployments',
      order: 3,
      onlyShowWhen: listenCapabilities(spi, [], ['deployments.showInGlobalNavigation', 'deployments.list']),
    },
  ];
}
